import classNames from 'classnames';
import _ from 'lodash';
import React, { useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { layoutDefaults } from '../../utils/layout-defaults';

const animationEnter = 'animate__animated animate__bounceIn animate__delay-1s';
const animationButton =
  'animate__animated animate__pulse animate__faster animate__delay-1s';
const delay1 = '0.6s';
const delay2 = '0.65s';
const service = 'name';

function OAuthNameButton({
  logo,
  analytics,
  accountAPI,
  onLoggedIn,
  onErrorMessage,
  children,
  className,
}) {
  const { analyticsFeatureUseEvent } = analytics;
  const [loading, setLoading] = useState(false);
  const { accountSignupFromRemote } = accountAPI;
  const [name, setName] = useState();
  const nameInputRef = useRef();
  const classes = useStyles();
  const { t } = useTranslation();

  const onClick = async () => {
    analyticsFeatureUseEvent('auth naming click');
    onErrorMessage?.call(this, null, service);

    if (_.isEmpty(name)) {
      onErrorMessage?.call(this, t('oauth.type-your-name'), service);
      return;
    }

    setLoading(true);

    try {
      const response = await accountSignupFromRemote(name);
      await onLoggedIn?.call(this, response.data, service);
    } catch (error) {
      if (error.response?.status === 422) {
        const validation = error.response?.data?.find(() => true);
        onErrorMessage?.call(this, validation.message, service);
      } else {
        onErrorMessage?.call(this, t('oauth.try-again'), service);
      }
    }

    setLoading(false);
  };

  const didNameChange = (event) => {
    const { value } = event.target;
    onErrorMessage?.call(this, null, service);
    setName(value);
  };

  return (
    <Form>
      <Form.Control
        value={name}
        ref={nameInputRef}
        type="text"
        disabled={loading}
        placeholder={t('oauth.name.placeholder')}
        className={classes.input}
        onChange={didNameChange}
      />

      {/* <Button
        style={{ '--animate-delay': delay2 }}
        className={classNames(classes.button, animationButton)}
        size="md"
        onClick={loading ? null : onClick}
      >
        <div className={classes.oauthButton}>
          {loading ? (
            <Spinner animation="border" className={classes.spinner} />
          ) : (
            children
          )}
        </div>
      </Button> */}

      <Button
        style={{
          backgroundColor: '#1460c3',
          color: 'white',
          '--animate-delay': delay2,
        }}
        // className={classNames(classes.button, animationButton)}
        className={classNames(className, classes.button, animationButton)}
        size="md"
        // disabled={loading}
        onClick={loading ? null : onClick}
      >
        <div className={classes.oauthButton}>
          <div className={classes.oauthButtonLeft}>
            <img
              src={logo}
              className={classNames(classes.logo, animationEnter)}
              style={{ '--animate-delay': delay1 }}
              alt="website logo"
            />
            {children}
          </div>
          {loading && (
            <Spinner animation="border" className={classes.spinner} />
          )}
        </div>
      </Button>
    </Form>
  );
}

const useStyles = createUseStyles({
  container: {
    border: '1px solid white',
  },
  input: {
    marginBottom: '0px !important;',
  },
  button: {
    width: '100%',
    // backgroundColor: "white",
    textAlign: 'left',
    // boxShadow: `0px 2px px #777`,
  },
  oauthButton: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  oauthButtonLeft: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  logo: {
    height: 28,
    width: 28,
    marginRight: layoutDefaults.smallHorizontalMargin,
    // border: "1px solid red",
  },
  spinner: {
    color: layoutDefaults.secondaryColor,
    fontSize: layoutDefaults.fontSize,
    height: 26,
    width: 26,
  },
});

export { OAuthNameButton };
